import Vue from "vue";
import store from "@/store";
import router from "@/router/index";
import axios from "axios";
import VueAxios from "vue-axios";
import _, { debounce } from "lodash";
import tokenUtils from "@/utils/tokens";

const camelcaseObjectDeep = require("camelcase-object-deep");

Vue.use(VueAxios, axios);
// for multiple parallel requests
let isRefreshing = false;
let failedQueue = [];

const processQueue = (error, token = null) => {
    failedQueue.forEach((prom) => {
        if (error) {
            prom.reject(error);
        } else {
            prom.resolve(token);
        }
    });
    failedQueue = [];
};

const toastedErrorDebounce = debounce(function (errMsg) {
    return $VUE_APP.$toasted.error(errMsg);
}, 1000);

export const $http = axios.create({
    baseURL: "",
    // baseURL: process.env.VUE_APP_ROOT_API,
    headers: {
        Authorization: `Bearer ${tokenUtils.getToken("authorization")}`,
        "Api-Version": "v1",
        Accept: "application/json",
    },
});
$http.interceptors.request.use((config) => {
    config.headers["Authorization"] = `Bearer ${tokenUtils.getToken("authorization")}`;
    config.headers["Accept-Locale"] = store.getters.currentLanguage.translationKey;
    config.headers["Country-Id"] = 242;
    config.headers["Session-Id"] = localStorage.getItem("session-id") || "";
    return config;
});
$http.interceptors.response.use(
    (response) => {
        if (response.headers.hasOwnProperty("session-id")) {
            localStorage.setItem("session-id", response.headers["session-id"]);
        }
        response.data = camelcaseObjectDeep(response.data);
        return response;
    },
    (error) => {
        console.log(
            "interceptors.request.use error",
            `Bearer ${tokenUtils.getToken("refresh")}`
        );

        const originalRequest = error.config;

        if (error.response.data.error && "message_key" in error.response.data.error) {
            if (error.response.data.error.message_key !== "unauthorized") {
                if (error.response.data.error.message_key !== "wrong_credentials") {
                    console.log("error.response.data", error.response.data.validation);
                    const errorObject = error.response.data.validation;
                    const errorKeys = Object.keys(errorObject);

                    console.log("errorObject", errorObject);

                    if (!_.isEmpty(errorObject) && !_.isEmpty(errorKeys)) {
                        for (const errorKey of errorKeys) {
                            toastedErrorDebounce(
                                $VUE_APP.$t(
                                    _.isArray(errorObject[errorKey])
                                        ? errorObject[errorKey][0]
                                        : errorObject[errorKey]
                                )
                            );
                        }
                        // $VUE_APP.$t(
                        //     error.response.data.validation.email[0]
                        //         ? error.response.data.validation.email[0]
                        //         : error.response.data.validation.token[0]
                        //         ? error.response.data.validation.token[0]
                        //         : error.response.data.error.message_key
                        // )
                    }
                } else {
                    toastedErrorDebounce($VUE_APP.$t("wrongCredentials"));
                }
            }
        }

        if (
            error.response.status === 401 &&
            router.app._route.name !== "sing-in" &&
            !originalRequest.retry
        ) {
            if (isRefreshing) {
                return new Promise((resolve, reject) => {
                    failedQueue.push({ resolve, reject });
                })
                    .then((token) => {
                        originalRequest.headers.Authorization = `Bearer ${token}`;
                        return Vue.axios(originalRequest);
                    })
                    .catch((error) => error);
            }

            originalRequest.retry = true;
            isRefreshing = true;
            return new Promise((resolve, reject) => {
                axios({
                    method: "post",
                    url: `${process.env.VUE_APP_ROOT_AUTH}tokens/refresh`,
                    headers: {
                        Authorization: `Bearer ${tokenUtils.getToken("refresh")}`,
                        "Api-Version": "v1",
                        Accept: "application/json",
                        "Country-Id": 242,
                        "Accept-Language": store.getters.currentLanguage.translationKey,
                        "Session-Id": localStorage.getItem("session-id") || "",
                    },
                })
                    .then((response) => {
                        response.data = camelcaseObjectDeep(response.data);

                        store.dispatch(`auth/AUTH_SET_TOKENS`, response.data.data);

                        originalRequest.headers.Authorization = `Bearer ${response.data.data[0].token}`;
                        axios.defaults.headers.Authorization = `Bearer ${response.data.data[0].token}`;

                        processQueue(null, response.data.data[0].token);
                        resolve(Vue.axios(originalRequest));
                    })
                    .catch((error) => {
                        store.dispatch(`auth/AUTH_REMOVE_TOKENS`);

                        router.push({ name: "sing-in" });

                        processQueue(error, null);

                        reject(error);
                    })
                    .then(() => {
                        isRefreshing = false;
                    });
            });
        }
        throw error;
    }
);

export default function install(Vue) {
    Object.defineProperty(Vue.prototype, "$http", {
        get() {
            return $http;
        },
    });
}
